import React from "react";
import {
    withStyles,
    CircularProgress,
    Switch,
  } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { findAllProcedimentosTable, findByIdProcedimento, inativarProcedimentos, inativarTodosProcedimentos, procedimentoNomeJaExistente, procedimentosCsv, saveProcedimento } from "../../../services/ProcedimentoService";
import { findAllLigacaoProduto } from "../../../services/ProdutoService";
import Notification from '../../../components/Notification';
import { findAllLigacaoConvenio } from '../../../services/ConvenioService';
import string from '../../../utils/string';
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import { tabs } from "../../../stores/ModalConfiguracoes.store";
import { findAllProcedimentoAuditByProcedimentoId, findAllProcedimentoAuditByUnidade } from "../../../services/AuditoriaService";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import ContentConfiguracoes from "../Components/ContentConfiguracoes";
import Table from "../../../components/Table/Table";
import { columnsProcedimentos, optionsTipo, tabsModal } from "../Constants/Constants";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import AddIcon from "../../../components/Icon/AddIcon";
import ModalConfiguracoesTabs from "../Components/Modal/ModalConfiguracoesTabs";
import { TextField, TextFieldSearch } from "../../../components/TextField";
import ConvenioList from "../Components/Modal/Tabs/ConvenioList";
import ProdutoList from "../Components/Modal/Tabs/ProdutoList";
import ModalConfirmacao from "../../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import WarningIcon from "../../../components/Icon/Warning";
import { Button } from "../../../components/ui/Buttons";
import { getWhitelabelAtual } from "../../../services/WhitelabelService";
import { ReactSelect } from "../../../components/Select/SelectSearch";
import InputForm from "../../../components/Input/InputForm";
import InputMaskCurrency from "../../../components/Input/InputMaskCurrency";
import DownaloadIcon from "../../../components/Icon/DownloadIcon";
import { base64Convert } from "../../../utils/base64ToCsv";

const procedimentoSelectedDefault = {
    id: null,
    nome: "",
    status: true,
    valorCusto:0,
    tuss22ProcedimentoEventoSaude: null,
    convenioProcedimentos: [],
    convenioAgendamentoTipo: [],
    produtoProcedimento: [],
    tiposProcedimentos: optionsTipo[0],
    orientacoes:"",
    especialidades: [],
};

const options3dpe = [
    {
        label: 'Revest. EVA',
        value: 'REVESTIMENTO_EVA'
    },

    {
        label: 'Revest. Tecido',
        value: 'REVESTIMENTO_TECIDO'
    },

    {
        label: 'Palmilha',
        value: 'PALMILHA'
    },

    {
        label: 'Chinelo',
        value: 'CHINELO'
    },
    {
        label: 'Elemento',
        value: 'ELEMENTO'
    },
]

@inject('SADTStore', 'prontuarioStore', 'modalConfiguracoesStore', 'auditoriaStore', 'procedimentoStore','unidadeStore')
@observer
class Procedimentos extends React.Component {
    state = {
        notification: {
            isOpen: false,
            message: "",
            variant: "",
        },
        search: "",
        isLoading: false,
        procedimentos: [],
        procedimentoSelected: procedimentoSelectedDefault,
        loadingSave: false,
        status: true,
        tipoOpcao: "convenio",
        ordenarNome: true,
        ordenarStatus: true,
        pageNumber: 0,
        last: false,
        pageNumberModal: 0,
        loadingProcedimentos: false,
        lastConvenio: false,
        disableButton: false,
        loadingModal: false,
        convenios: [],
        produtos: [],
        ordenarTabela: {
            sortField: "nome",
            sortDir: "ASC",
        },
        tabSelected: tabs.INFORMACOES,
        propsTabsModal: {
            options: ["Convênio", "Produto"],
            tabSelected: tabsModal.CONVENIO,
            valueSearch: "",
            quantidades: [0, 0],
            observacao:""
        },
        openAlertProcedimentos: false,
        propsTabsAuditoria: {
            tabSelected: tabs.INFORMACOES
        },
        isLoadingCsv:false,
        selectedProcedimentos: [],
        isLoadingBulkInactivate: false,
        openModalConfirmacao: false,
        selectAll: false,
        totalProcedimentos: 0
    }

    whiteLabel = getWhitelabelAtual();
    is3dpe = this.whiteLabel?.nome === "_3DPE";

    componentDidMount() {
        const { modalConfiguracoesStore } = this.props;
        this.getConfiguracaoUnidade()
        this.loadProcedimentos();
        this.setAuditoriaTela();

        modalConfiguracoesStore.titulo="procedimento";
        modalConfiguracoesStore.opcao="procedimento";
    };

    getConfiguracaoUnidade = () => {
        const { unidadeStore } = this.props
        unidadeStore.inicializaConfiguracaoUnidade()
        this.setState({ utilizaDuracaoProcedimentosTipoConsulta: !!unidadeStore.configuracaoUnidade?.utilizaDuracaoProcedimentosTipoConsulta })
    }

    changeTabSelectedModal = async(tabSelected) => {
        const { propsTabsModal } = this.state;

        this.setState(
            {
              convenios: [],
              produtos: [],
              pageNumberModal: 0,
              lastModal: false,
              tipoOpcao: tabSelected === 0 ? "convenio" : "produto",
              propsTabsModal: {
                ...propsTabsModal,
                tabSelected: tabSelected,
                valueSearch: "",
            }
            },
            () =>
            tabSelected === 0
                ? this.loadConvenios()
                : this.loadProdutos()
        );
    };

    setAuditoriaTela = () => {
        const { auditoriaStore } = this.props;

        auditoriaStore.auditoriaProps={
            ...auditoriaStore.auditoriaProps,
            auditoria: "o procedimento",
            auditoriaTela: "procedimento",
        };

        auditoriaStore.load={
            query: findAllProcedimentoAuditByUnidade, 
            variableName: "",
            variableId: "", 
        };
    };

    loadProcedimentos = async() => {
        try {
            this.setState({ isLoading: true });
            const response = await findAllProcedimentosTable({
                nome: this.state.search || "",
                ...(this.state.status !== null && {ativo: this.state.status}),
                pageableDTO:{
                    pageNumber: this.state.pageNumber,
                    pageSize: 30,
                    sortDir: this.state.ordenarTabela.sortDir,
                    sortField: this.state.ordenarTabela.sortField
                }
            })
            
            const { last, content, totalElements } = response;
            const { selectAll, selectedProcedimentos } = this.state;
            
            const novosProced = selectAll 
                ? content.map(item => ({id: item.id}))
                : [];
            
            const selectedAtualizado = selectAll
                ? [...selectedProcedimentos, ...novosProced]
                : selectedProcedimentos;

            this.setState({
                procedimentos: [...this.state.procedimentos, ...content],
                last: last,
                totalProcedimentos: totalElements || 0,
                selectedProcedimentos: selectedAtualizado
            })
            
        } catch(error) {
            const notification = {
                isOpen: true,
                variant: "error",
                message: "Erro ao carregar lista de procedimentos"
            };
            this.showAlertMessage(notification);

        } finally {
            this.setState({ isLoading: false })

        }
            
    };

    loadMore = () => {
        const { isLoading, procedimentos } = this.state;
        if (isLoading) {
            return;
        }

        this.setState({ pageNumber: procedimentos.length > 0 ? this.state.pageNumber + 1 : 0 });

        this.loadProcedimentos();
    };

    handleClickSearch = () => {
        this.setState({
            procedimentos: [],
            pageNumber: 0
        }, () => this.loadProcedimentos());
    };

    handleClickClear = () => {
        this.setState({
            search: "",
            procedimentos: [],
            pageNumber: 0,
        }, () => this.loadProcedimentos());
    };

    onChangeSearch = (e) => {
        let search = e.target.value;
        this.setState({ search })
    };

    onKeypressSearch = (e) => {
        if (e.key === 'Enter' && this.state.search.length >= 3) {
            this.setState({
                procedimentos: [],
                pageNumber: 0,
            });
            this.loadProcedimentos();
        }
    };

    handleChangeStatus = async (e) => {
        const { procedimentoSelected } = this.state;
        this.setState({
            procedimentoSelected: {
                ...procedimentoSelected,
                ativo: !procedimentoSelected.ativo
            }
        });
    };

    handleProcedimentoOdontologico = () => {
        const { procedimentoSelected } = this.state;

        const isOdontologico = procedimentoSelected.tiposProcedimentos && procedimentoSelected.tiposProcedimentos.some(item => item.value === "ODONTOLOGICO");
        const tiposProcedimentos = isOdontologico ? [{
            label: "Procedimento",
            value: "PROCEDIMENTO",
          },] : optionsTipo;

        this.setState({
            procedimentoSelected: {
                ...procedimentoSelected,
                tiposProcedimentos,
            }
        });
    };

    setAuditoriaModal = () => {
        const { auditoriaStore } = this.props;
        const { procedimentoSelected } = this.state;

        auditoriaStore.auditoriaProps={
            ...auditoriaStore.auditoriaProps,
            auditoria: "o procedimento",
            auditoriaTela: "procedimento",
        };

        auditoriaStore.load={
            query: findAllProcedimentoAuditByProcedimentoId, 
            variableName: "procedimentoId",
            variableId: procedimentoSelected.id, 
        };
    };

    handleClickNovoProcedimento = async () =>{
        const { modalConfiguracoesStore } = this.props;
        const { propsTabsModal } = this.state;

        this.setState({ 
            procedimentoSelected: { 
                ativo: true,
                convenioProcedimentos: [],
                produtoProcedimentos: [],
                tiposProcedimentos: [optionsTipo[0]],
                especialidades: [],
            },
            tipoOpcao: "convenio",
            propsTabsModal: {
                ...propsTabsModal,
                tabSelected: 0,
                valueSearch: "",
                quantidades: [0, 0]
            },
            convenios: [], 
            pageNumberModal: 0,
        }, () => {
            this.loadConvenios();
            modalConfiguracoesStore.showModal = true;
        });
        
    };

    convertAndDowloadCsv = async (base64) => {
        const blob = await base64Convert(base64);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = "procedimentos.csv";
        link.href = url;
        document.body.appendChild(link)
        link.click();
    };

    handleClickDownLoadCsv = async () => {
        try {
            this.setState({ isLoadingCsv: false });
            const { search } = this.state;
            const variables = {
                pageableDto: {
                    sortDir: this.state.ordenarTabela.sortDir,
                    sortField: this.state.ordenarTabela.sortField,
                },
                ...(search && { search: search }),
                ativo: true,
            };

            const response = await procedimentosCsv(variables);
            if (response) {
                this.convertAndDowloadCsv(response);
            }
        } catch (error) {
            this.showAlertMessage({ isOpen: true, message: "Erro ao gerar Csv", variant: "error" })
        } finally {
            this.setState({ isLoadingCsv: false });
        }
    };

    loadMoreModal = () => {
        const { loadingModal, tipoOpcao, convenios, produtos, pageNumberModal } = this.state;
        if (loadingModal) {
            return;
        };

        const listaOpcao = tipoOpcao === "convenio" ? convenios : produtos;

        this.setState({ pageNumberModal: listaOpcao.length > 0 ? pageNumberModal + 1 : 0 }, () => {
            this.loadListaModal();
        });
    };

    loadListaModal = () => {
        const { tipoOpcao } = this.state;

        tipoOpcao === "convenio" ? this.loadConvenios() : this.loadProdutos();
    };

    alterarOrdemNome = () => {
        this.setState({
            procedimentos: [],
            ordenarNome: !this.state.ordenarNome,
            sortDir: this.state.ordenarNome ? 'DESC' : 'ASC',
            sortField: 'nome',
        });
    };

    alterarOrdemStatus = () => {
        this.setState({
            procedimentos: [],
            ordenarStatus: !this.state.ordenarStatus,
            sortDir: this.state.ordenarStatus ? 'DESC' : 'ASC',
            sortField: 'ativo',
        })
    };

    handleClickOrdenar = async (value) => {
        const { ordenarTabela } = this.state;

        const sortDir = ordenarTabela.sortField !== value ? "ASC" : (ordenarTabela.sortDir === "ASC" ? "DESC" : "ASC")
        const status = value === 'ativo' ? sortDir === 'ASC' : this.state.status;

        this.setState({
            ordenarTabela: { 
              sortDir: sortDir,
              sortField: value,
            },
            procedimentos: [],
            pageNumber: 0,
            status
        }, () => this.loadProcedimentos());
    };

    onCloseModal = () => {
        const { modalConfiguracoesStore } = this.props;

        modalConfiguracoesStore.showModal = false;

        this.setState({ 
            propsTabs: {
                ...this.state.propsTabs,
                valueSearch: "",
            }
         });
    };

    save = procedimento => {
        const { modalConfiguracoesStore } = this.props;

        this.setState({ loadingSave: true });

        saveProcedimento(procedimento)
            .then(() => {
                this.setState({
                    convenioSelected: undefined,
                    propsTabs: {
                        ...this.state.propsTabs,
                        valueSearch: ""
                    },
                    convenios: [],
                    pageNumber: 0,
                    procedimentos: [],
                    pageNumberModal: 0,
                });
                this.showAlertMessage({
                    isOpen: true,
                    variant: "success",
                    message: "Procedimento salvo com sucesso"
                });
                modalConfiguracoesStore.showModal = false;
                this.loadProcedimentos();
            })
            .catch(error => {
                const notification = {
                    isOpen: true,
                    variant: "error",
                    message: "Erro ao salvar o procedimento"
                };
                this.showAlertMessage(notification);
            })
            .finally(() => {
                this.setState({ loadingSave: false });
            });
    };

    handleEditar = async (id, isDuplicar=false) => {
        const { modalConfiguracoesStore } = this.props;
        const selecionado = await findByIdProcedimento(id);
        const procedimento = selecionado.data.data.findByIdProcedimento;
        const valoresComVirgula = procedimento.convenioProcedimentos.map(item => {
            return({
                ...item,
                valor: item.valor ? String(item.valor.toFixed(2)).replace('.', ',') : item.valor,
            })
        });
        let tiposProcedimentos = [];

        if(this.is3dpe) {
            tiposProcedimentos = procedimento.tiposProcedimentos?.length > 0 && options3dpe.filter(item => item.value === procedimento.tiposProcedimentos[0]) 
        } else {
            tiposProcedimentos = procedimento.tiposProcedimentos.map(item => ({
                label: string.capitalize(item),
                value: item,
            }))
        }

        const procedimentoAdaptado = {
            ...procedimento,
            tiposProcedimentos,
            convenioProcedimentos: valoresComVirgula
        }

        const selecionadoComId = {
            ...procedimentoAdaptado,
            id: id,
            especialidades: procedimento.especialidades || []
        }

        if(procedimento.tuss22ProcedimentoEventoSaude) {
            const {descricao, codigoTermo, codigoTermoDescricao} = procedimento.tuss22ProcedimentoEventoSaude;

            selecionadoComId.tuss22ProcedimentoEventoSaude = {
                ...procedimento.tuss22ProcedimentoEventoSaude,
                descricao: {value: descricao, label: descricao},
                codigoTermo: {value: codigoTermo, label: codigoTermo},
                codigoTermoDescricao: {value: codigoTermoDescricao, label: codigoTermoDescricao}
            }
        };

        if (isDuplicar) {
            selecionadoComId.id=null;
            selecionadoComId.nome=`${selecionadoComId.nome} - cópia`;
        };

        this.setState({ 
            procedimentoSelected: selecionadoComId,
            propsTabsModal: {
                ...this.state.propsTabsModal,
                tabSelected: 0,
                valueSearch: "",
                quantidades: [ selecionadoComId?.convenioProcedimentos?.length, selecionadoComId?.produtoProcedimentos?.length ]
            },
            propsTabsAuditoria: {
                tabSelected: 0
            },
            convenios: [], 
            pageNumberModal: 0,
            tipoOpcao: "convenio"
        });

        await this.loadConvenios(id);
        modalConfiguracoesStore.showModal = true;
    };

    onChangeSearchModal = (e) => {
        const { propsTabsModal } = this.state;

        let value = e.target.value;
        this.setState({ propsTabsModal: {
            ...propsTabsModal,
            valueSearch: value
        } })
    };

    handleClickClearModal = () => {
        this.setState({
            propsTabsModal: {
                ...this.state.propsTabsModal,
                valueSearch: "",
            },
            convenios: [],
            produtos: [],
            pageNumberModal: 0,
        }, () => {
            this.loadListaModal();
        });
    };

    onKeypressSearchModal = (e) => {
        const { propsTabsModal } = this.state;

        if (e.key === 'Enter' && propsTabsModal.valueSearch.length >= 3) {
            this.setState({
                convenios: [],
                produtos: [],
                pageNumberModal: 0,
            }, () => {
                this.loadListaModal();
            });
        }
    };

    handleClickSearchModal = () => {
        this.setState({
            convenios: [],
            produtos: [],
            pageNumberModal: 0,
        }, () => {
            this.loadListaModal();
        });
    }

    loadConvenios = async () => {
        const { propsTabsModal, pageNumberModal, procedimentoSelected } = this.state;
        this.setState({ loadingModal: true });

        try {
            const response = await findAllLigacaoConvenio({
                search: propsTabsModal.valueSearch,
                entidadeId: procedimentoSelected?.id,
                pageableDto: {
                    sortDir: "ASC",
                    sortField: "descricao",
                    pageNumber: pageNumberModal,
                    pageSize: 10,
                },
                tipoLigacaoEntidadesValores: "PROCEDIMENTO"
            });
    
            const { content, last } = response || {};
            const convenios = content.map(convenioItem => {
                const { nome, descricao, id, dataFimVigencia, dataInicioVigencia, valor } = convenioItem || {};
                const convenioChecked = procedimentoSelected?.convenioProcedimentos && procedimentoSelected.convenioProcedimentos.find(item => item.convenio.id === Number(convenioItem.id));
                
                return {
                    convenio: {
                        nome,
                        descricao,
                        id,
                        checked: !!convenioChecked,
                    },
                    valor: valor || 0,
                    vigencia:{
                        dataFimVigencia,
                        dataInicioVigencia,
                        valor: valor || 0
                    }
                }
            });

            this.setState({
                convenios: [...this.state.convenios, ...convenios],
                lastModal: last
            })

        } catch(error) {
            const notification = {
                isOpen: true,
                variant: "error",
                message: "Erro ao carregar a lista de convênios."
            };
            this.showAlertMessage(notification);

        } finally {
            this.setState({ loadingModal: false })
            
        }
    };

    loadProdutos = async () => {
        const { propsTabsModal, pageNumberModal, procedimentoSelected } = this.state;
        const { valueSearch } = propsTabsModal;
        this.setState({ loadingModal: true });
        try {
            const response = await findAllLigacaoProduto({
                search: valueSearch,
                entidadeId: procedimentoSelected?.id,
                pageableDto:{
                    pageNumber: pageNumberModal,
                    pageSize: 10,
                    sortDir: "ASC",
                    sortField: "nome"
                },
                tipoLigacaoEntidadesValores: "PROCEDIMENTO"
            });

            const { content, last } = response || {} ; 

            const produtos = content.map(produtoItem => {
                const produtoChecked = procedimentoSelected.produtoProcedimentos.find(item => item.produto.id === produtoItem.id);
                return {
                    produto: {
                        nome: produtoItem.nome,
                        descricao: produtoItem.descricao,
                        id: produtoItem.id,
                        checked: !!produtoChecked
                    },
                    quantidade: produtoChecked?.quantidade || 0
                }
            })


            this.setState({
                produtos: [...this.state.produtos, ...produtos],
                lastModal: last
            })

        } catch(error) {
            const notification = {
                isOpen: true,
                variant: "error",
                message: "Erro ao carregar a lista de procedimentos"
            };
            this.showAlertMessage(notification);

        } finally {
            this.setState({ loadingModal: false })
        }


    }

    handleChangeTuss = (value) => {
        if(value) {
            this.setState(prevState => ({
                procedimentoSelected: {
                    ...prevState.procedimentoSelected,
                    tuss22ProcedimentoEventoSaude: {
                        id: value.id,
                        descricao: {value: value.descricao, label: value.descricao},
                        codigoTermo: {value: value.codigoTermo, label: value.codigoTermo},
                        codigoTermoDescricao: {value: value.codigoTermoDescricao, label: value.codigoTermoDescricao}
                    },
                    nome: value.codigoTermoDescricao
                },
            }));
        } else {
            this.setState(prevState => ({
                procedimentoSelected: {
                    ...prevState.procedimentoSelected,
                    tuss22ProcedimentoEventoSaude: null
                },
            }));
        }
    }

    handleChange = (event, item, index) => {
        const { name, value } = event.target;
        const { procedimentoSelected, tipoOpcao } = this.state;
        const lista =  tipoOpcao === "convenio" ? "convenios" : "produtos";
        const procedimentoConveniosProdutos = tipoOpcao === "convenio" ? "convenioProcedimentos" : "produtoProcedimentos"; 

        if (item) {
            item[name] = 
                name === "valor"
                    ? value
                    : string.numberMaskToFloat(value);

            const indexSelecionado = procedimentoSelected[procedimentoConveniosProdutos].findIndex(
              (convenio) => convenio[tipoOpcao].id === item[tipoOpcao].id
            );
            
            if (indexSelecionado >= 0) {
                let object = procedimentoSelected;
                object[procedimentoConveniosProdutos][indexSelecionado][name] = item[name];
                this.setState({procedimentoSelected: object});
            }

        } else {
            this.setState(prevState => ({
                procedimentoSelected: {
                    ...prevState.procedimentoSelected,
                    [name]: value
                },
            }));
        }

        if(name === "valor" || name === "quantidade"){
            this.setState({
                [lista]: [
                  ...this.state[lista].slice(0, index),
                  {
                    ...this.state[lista][index],
                    [name]: value,
                  },
                  ...this.state[lista].slice(index+1, this.state[lista].length)
                ]
            });
        }
    };

    handleChangeCheckbox = async (item, index) => {
        const { tipoOpcao, procedimentoSelected, propsTabsModal } = this.state;

        const lista = tipoOpcao === "convenio" ? "convenios" : "produtos";
        const isChecked = !item[tipoOpcao].checked;
        item[tipoOpcao].checked = isChecked;

        let updatedProcedimentoSelected = {...procedimentoSelected};

        const updateProcedimentos = (procedimentos, id, value) => {
        if (value) {
            procedimentos.push({ [tipoOpcao]: { id }, ...value });
        } else {
            procedimentos = procedimentos.filter(each => each[tipoOpcao].id !== id);
        }
        return procedimentos;
        };
        if (tipoOpcao === "convenio") {
            updatedProcedimentoSelected.convenioProcedimentos = isChecked ? updateProcedimentos(
                updatedProcedimentoSelected.convenioProcedimentos,
                item.convenio.id,
                { valor: item.valor }
            ) : updatedProcedimentoSelected.convenioProcedimentos.filter(itemConvenio => itemConvenio.convenio.id !== item.convenio.id);
            const quantidades = [
                isChecked ? propsTabsModal.quantidades[0]+1 : propsTabsModal.quantidades[0]-1,
                propsTabsModal.quantidades[1]
            ];
            this.setState({
                propsTabsModal: {
                ...propsTabsModal,
                quantidades
                }
            });
        } else {
        updatedProcedimentoSelected.produtoProcedimentos = isChecked ? updateProcedimentos(
            updatedProcedimentoSelected.produtoProcedimentos,
            item.produto.id,
            { quantidade: item.quantidade }
        ): updatedProcedimentoSelected.produtoProcedimentos.filter(itemProduto => itemProduto.produto.id !== item.produto.id);

        const quantidades = [
            propsTabsModal.quantidades[0],
            isChecked ? propsTabsModal.quantidades[1]+1 : propsTabsModal.quantidades[1]-1
        ];
        this.setState({
        propsTabsModal: {
            ...propsTabsModal,
            quantidades
        }
        });
        }

        const updatedLista = [
        ...this.state[lista].slice(0, index),
        {
            ...this.state[lista][index],
            checked: isChecked,
        },
            ...this.state[lista].slice(index+1)
        ];

        this.setState({ 
            procedimentoSelected: updatedProcedimentoSelected,
            [lista]: updatedLista
        });
    };

    saveProcedimentoComMesmoNome = () => {
        const { procedimentoSelected } = this.state;

        this.setState({
            procedimentoSelected: {
                ...procedimentoSelected,
                nome: `${procedimentoSelected.nome} - cópia`
            }
        }, () => {
            this.closeModalConfirmacao();
            this.handleSave({isSaveMesmoNome: true});
        });
    };

    closeModalConfirmacao = () => {
        this.setState({ openAlertProcedimentos: false })
    }

    voltarMudarNome = () => {
        const { modalConfiguracoesStore } = this.props;
        this.closeModalConfirmacao();
        modalConfiguracoesStore.showModal=true;
    };

    verificaProcedimentoComMesmoNome = async(nomeProcedimento) => {
        const { procedimentoSelected } = this.state;
        const existeMesmoNome = await procedimentoNomeJaExistente(nomeProcedimento);
        this.setState({ 
            openAlertProcedimentos: existeMesmoNome && !procedimentoSelected.id,
        })

        return existeMesmoNome && !procedimentoSelected.id;
    };

    contemErro = () => {
        const { procedimentoSelected } = this.state;
        const { nome } = procedimentoSelected || {};
        
        const errorNome = !nome || string.isEmpty(nome);
    
        const message = {
            nome: "Digite o nome do procedimento.",
        };
    
        if (errorNome ) {
            const notification = {
                isOpen: true,
                variant: "error",
                message: errorNome && message.nome 
            };
            this.showAlertMessage(notification);
        }
    
        return errorNome ;
    };

    handleSave = async ({isSaveMesmoNome=false}) => {
        try{
            const { modalConfiguracoesStore } = this.props;

            let procedimento = this.state.procedimentoSelected;
            this.setState({ 
                disableButton: true,
                loadingSave: true,
            })

            if(this.contemErro()) {
                return 
            }

            const existeMesmoNome = await this.verificaProcedimentoComMesmoNome(procedimento.nome)

            if(!isSaveMesmoNome && existeMesmoNome) return;
    
            if(procedimento.tuss22ProcedimentoEventoSaude) {
                const {id, descricao, codigoTermo} = procedimento.tuss22ProcedimentoEventoSaude;
    
                procedimento.tuss22ProcedimentoEventoSaude = {
                    id,
                    descricao: descricao.value,
                    codigoTermo: codigoTermo.value
                }
            }
    
            const convenioProcedimentosRetiraMascaraValor = procedimento.convenioProcedimentos.map(item => {
                const { valorVigente, valor, ...rest } = item
                if (procedimento?.id) {
                    return (
                        {
                            ...rest,
                            valores: {
                                valor: item.valor ? string.removeMask(item.valor, "R$") : "0",
                                dataInicioVigencia: valorVigente?.dataInicioVigencia,
                                dataFimVigencia: valorVigente?.dataFimVigencia,
                                id: valorVigente?.id
                            },
                        }
                    )
                } else {
                    return (
                        {
                            ...item,
                            valor: item.valor ? string.removeMask(item.valor, "R$") : "0",
                        }
                    )
                }
            });

            const possuiTiposProcedimentos = procedimento.tiposProcedimentos && procedimento.tiposProcedimentos.length > 0;
            const tiposProcedimentos = possuiTiposProcedimentos ? procedimento.tiposProcedimentos.map(item => item.value) : ["PROCEDIMENTO"];
    
            procedimento = {
                ...procedimento,
                tiposProcedimentos,
                convenioProcedimentos: convenioProcedimentosRetiraMascaraValor
            };
    
            await saveProcedimento(procedimento);
            this.showAlertMessage({
                isOpen: true,
                variant: "success",
                message: "Procedimento salvo com sucesso"
            });
            modalConfiguracoesStore.showModal = this.state.openAlertProcedimentos;
        }catch{
            const notification = {
                isOpen: true,
                variant: "error",
                message: "Erro ao salvar o procedimento"
            };
            this.showAlertMessage(notification);

        }finally{
            this.setState({
                procedimentos: [],
                pageNumber: 0,
                disableButton: false,
                loadingSave: false,
            }, () =>  this.loadProcedimentos())
           
        }
    };

    handleClickRow = (id) => {
        this.handleEditar(id);
    };

    handleDuplicar = async(id) => {
        this.handleEditar(id, true);
    };

    handleAtivar = async (id) => {
        const { modalConfiguracoesStore } = this.props;
        const selecionado = await findByIdProcedimento(id);
        const procedimento = selecionado.data.data.findByIdProcedimento;

        if (procedimento?.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao) {
            delete procedimento.tuss22ProcedimentoEventoSaude.codigoTermoDescricao;
        }

        const selecionadoAtivo = {
            ...procedimento,
            id,
            ativo: true
        }
        await saveProcedimento(selecionadoAtivo);
        this.setState({
            procedimentos: [],
            pageNumber: 0,
        });
        modalConfiguracoesStore.showModal=false;
        this.loadProcedimentos();
    };

    changeTabModalAuditoriaSelected = async(tabSelected) => {
        const { auditoriaStore } = this.props;
        const { procedimentoSelected } = this.state;

        auditoriaStore.auditoriaProps={
            ...auditoriaStore.auditoriaProps,
            pageNumber: 0,
            lastPage: false,
            auditorias: [],
        };

        if (tabSelected === 2) {
            auditoriaStore.load={
                query: findAllProcedimentoAuditByProcedimentoId, 
                variableName: "procedimentoId",
                variableId: procedimentoSelected.id,
            }
            await auditoriaStore.loadAuditItems();
          }

        this.setState({
            propsTabsAuditoria: {
                tabSelected: tabSelected
            }
        })
    };

    handleInativar = async (id) => {
        const { modalConfiguracoesStore } = this.props;
        const selecionado = await findByIdProcedimento(id);
        const procedimento = selecionado.data.data.findByIdProcedimento;

        if (procedimento?.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao) {
            delete procedimento.tuss22ProcedimentoEventoSaude.codigoTermoDescricao;
        }

        const selecionadoInativo = {
            ...procedimento,
            id,
            ativo: false
        }
        await saveProcedimento(selecionadoInativo);
        this.setState({
            procedimentos: [],
            pageNumber: 0
        });
        modalConfiguracoesStore.showModal=false;
        this.loadProcedimentos();
    };

	showAlertMessage = (notification) => {
		this.setState({ notification: notification });

		const timeoutId = setTimeout(() => {
			this.closeAlertMessage();
			clearTimeout(timeoutId);
		}, 3000);
	};

	closeAlertMessage = () => {
		const notification = {
			isOpen: false,
			message: "",
		};
		this.setState({ notification: notification });
	};

    handleCodigoTermoDescricaoLoadOptions = async (search, loadedOptions, { page }) => {  
        return this.handleLoadMoreOptionsDescricao({
            search: search,
            loadedOptions,
            data: { page },
            method: "findAllTuss22ProcedimentoEventoSaude",
          });
    };

    handleLoadMoreOptionsDescricao = async ({ search, data, method }) => {
        const { procedimentoStore } = this.props;
        const { procedimentoSelected } = this.state;
        const { tiposProcedimentos } = procedimentoSelected || {};

        const isOdontologico = tiposProcedimentos?.some(item => item.value === "ODONTOLOGICO" || item === "ODONTOLOGICO");
        const tipos = isOdontologico ? ["ODONTOLOGICO"] : tiposProcedimentos?.map(item => item?.value || item);

        let searchFilter = {
            pageableDTO: {
                sortField: "codigoTermo",
                sortDir: "ASC",
                pageNumber: data.page,
                pageSize: 20
            },
            ativo: true,
            tiposProcedimentos: tipos,
        }
          
        if(search) {
            searchFilter.search = search;
        }

        const response = await procedimentoStore[method]({...searchFilter});
        return {
            options: response.content,
            hasMore: !response.last,
            additional: {
            page: data.page + 1
          }
        };
    };

    changeTabSelected = async(tabSelected) => {
        const { auditoriaStore } = this.props;
        const { procedimentoSelected } = this.state;

        auditoriaStore.auditoriaProps={
          ...auditoriaStore.auditoriaProps,
          pageNumber: 0,
          lastPage: false,
          auditorias: [],
        }

        if(tabSelected === 1) {
            auditoriaStore.load={
                query: findAllProcedimentoAuditByProcedimentoId, 
                variableName: "procedimentoId",
                variableId: procedimentoSelected.id, 
            }
            await auditoriaStore.loadAuditItems();
        }

        this.setState({ tabSelected })
    };

    onChangeSelectRevestimento = (e) =>{
        const {procedimentoSelected}=this.state
        this.setState({procedimentoSelected:{...procedimentoSelected,tiposProcedimentos:[e]}})
    }

    onChangeDuracao = (e) => {
        const { procedimentoSelected } = this.state
        this.setState({
            procedimentoSelected: {
                ...procedimentoSelected,
                duracaoProcedimento: e?.target?.value
            }
        })
    }
    
    handleChangeValorCusto = (e) => {
        const { procedimentoSelected } = this.state
        const value = e?.target?.value

        let valor;
        if (typeof value === "string") {
            const valorFormated = value.replace("R$", "")
            valor =parseFloat(valorFormated)
        }

        this.setState({
            procedimentoSelected: {
                ...procedimentoSelected,
                valorCusto: valor
            }
        })
    }

    handleChangeOrientacao = (e)=>{
        const value = e?.target?.value
        this.setState({ procedimentoSelected: {...this.state.procedimentoSelected, orientacoes: value}})
    }

    handleEspecialidade = (especialidades) => {
        this.setState(prevState => ({
            procedimentoSelected: {
                ...prevState.procedimentoSelected,
                especialidades: especialidades
            }
        }));
    }

    renderHeader = () => {
        const { classes ,unidadeStore} = this.props;
        const { procedimentoSelected, utilizaDuracaoProcedimentosTipoConsulta } = this.state;
        const utilizaValorCusto = unidadeStore?.configuracaoUnidade?.utilizaValorCustoProcedimento

        const verificaProcedimentoOdontologico = () => {
            const { procedimentoSelected } = this.state;
            const { tiposProcedimentos } = procedimentoSelected;
            const isOdontologico = tiposProcedimentos?.length > 0 && tiposProcedimentos?.some(item => item.value === "ODONTOLOGICO" || item === "ODONTOLOGICO");

            return isOdontologico;
        }

        return(
            <div className={classes.header}>
                <div className={classes.row}>
                    <div className={classes.contentNome}>
                        <div className={classes.titleRenderHeader}>
                        Nome do procedimento *Obrigatório
                        </div>
                        <TextField
                        id="cfg-pro-inp-nom"
                        name={"nome"}
                        className={classes.textField}
                        classes={{
                            root: classes.notchedOutlineTextField,
                        }}
                        placeholder={`Digite o nome do procedimento`}
                        value={procedimentoSelected?.nome}
                        onChange={this.handleChange}
                        />
                    </div>
                    {this.is3dpe ?
                        <div>
                            <label className={classes.labelResponsavel}>Tipo</label>
                            <ReactSelect
                                id="cfg-pro-sel-tip"
                                options={options3dpe}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={(e) => this.onChangeSelectRevestimento(e)}
                                className={classes.selectPalmilha}
                                value={procedimentoSelected?.tiposProcedimentos[0]}
                            />
                        </div>
                        :
                        <div className={classes.contentStatus}>
                        <div className={classes.titleField}>Odontológico</div>
                        <Switch
                            id="cfg-pro-swt-odo"
                            checked={verificaProcedimentoOdontologico()}
                            color="primary"
                            onClick={this.handleProcedimentoOdontologico}
                        />
                    </div>}
                    <div>
                    {procedimentoSelected?.id && (
                        <div className={classes.contentStatus}>
                            <div className={classes.titleField}>Status</div>
                            <Switch
                                id="cfg-pro-swt-sta"
                                checked={procedimentoSelected?.ativo}
                                color="primary"
                                onClick={this.handleChangeStatus}
                            />
                        </div>
                    )}
                    </div>
                </div>
                <div className={classes.containerCódigo}>
                    <div className={utilizaValorCusto ? classes.wrapperInputCodigo : classes.inputValorCod}>
                        <div className={classes.titleRenderHeader}>
                            Selecione código e descrição
                        </div>
                        <TextFieldSearch
                            id="cfg-pro-sel-cod"
                            key={`tiposProcedimentos-${procedimentoSelected?.tiposProcedimentos?.length}`}
                            placeholder='Pesquise por código ou descrição'
                            className={classes.renderHeaderInput}
                            classNotched={classes.notchedOutline}
                            loadOptions={this.handleCodigoTermoDescricaoLoadOptions}
                            withPaginate
                            value={procedimentoSelected.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao}
                            onChange={e => this.handleChangeTuss(e)}
                            debounceTimeout={300}
                            additional={{
                                page: 0,
                            }}
                        />
                    </div>
                    {utilizaDuracaoProcedimentosTipoConsulta &&
                        <div className={classes.contentInput}>
                            <div className={classes.titleRenderHeader}>Duração: </div>
                            <InputForm
                                id="cfg-pro-inp-dur"
                                type={'number'}
                                value={procedimentoSelected?.duracaoProcedimento}
                                onChange={(e) => this.onChangeDuracao(e)}
                                className={classes.inputContainer}
                                classes={{ input: classes.input }}
                            />
                        </div>}
                    {utilizaValorCusto &&
                        <div className={classes.containerInputValorCusto}>
                            <div className={classes.valorCusto}>Valor Custo</div>
                            <InputMaskCurrency
                                id="cfg-pro-inp-cus"
                                name={"valorCusto"}
                                value={procedimentoSelected?.valorCusto === 0 ? "" : procedimentoSelected?.valorCusto}
                                className={classes.inputValor}
                                onChange={(e) => this.handleChangeValorCusto(e)}
                            />
                        </div>}
                </div>
            </div>
        )
    };

    handleSelectProcedimento = (procedimento) => {
        const { selectedProcedimentos, selectAll } = this.state;
        const isSelected = selectedProcedimentos.some(item => item.id === procedimento.id);
        
        this.setState({
            selectedProcedimentos: isSelected 
                ? selectedProcedimentos.filter(item => item.id !== procedimento.id)
                : [...selectedProcedimentos, procedimento],
            selectAll: isSelected ? false : selectAll
        });
    };

    handleSelectAll = () => {
        const { procedimentos, selectAll } = this.state;
        
        const novoSelectAll = !selectAll;
        const procedimentosSelecionados = novoSelectAll 
            ? procedimentos.map(item => ({id: item.id}))
            : [];
      
        this.setState({
            selectedProcedimentos: procedimentosSelecionados,
            selectAll: novoSelectAll
        });
    }

    handleClickInativarSelecionados = () => {
        const { selectAll, selectedProcedimentos } = this.state;
        const { unidadeStore } = this.props;
        const { azulControleAtivado } = unidadeStore?.configuracaoUnidade || {};
        const horaAtual = new Date().getHours();
        
        if (selectAll) {
            if (azulControleAtivado && horaAtual < 18) {
                this.showAlertMessage({
                    isOpen: true,
                    variant: "error",
                    message: "A inativação de todos os procedimentos só é permitida após as 18h"
                });
                return;
            }
        } else {
            if (selectedProcedimentos.length > 50 && horaAtual < 18) {
                this.showAlertMessage({
                    isOpen: true,
                    variant: "error",
                    message: "O limite máximo para inativação parcial é de 50 procedimentos"
                });
                return;
            }
        }
        
        this.setState({ openModalConfirmacao: true });
    };

    handleClickInativar = async () => {
        try {
            const { selectAll } = this.state;
            this.setState({ isLoading: true });
            const variables= {
              procedimentos:this.state.selectedProcedimentos.map(item=>  {return {id:item?.id}})
            }
            selectAll ? await inativarTodosProcedimentos() : await inativarProcedimentos(variables)

            this.showAlertMessage({
                isOpen: true,
                variant: "success",
                message: "Procedimento(s) inativados com sucesso!"
            });

            this.setState({
                procedimentos: [],
                pageNumber: 0,
                openModalConfirmacao: false,
                selectedProcedimentos: [],
                selectAll: false
            });
            this.loadProcedimentos();
            
        } catch (error) {
            this.showAlertMessage({
                isOpen: true,
                variant: "error",
                message: "Erro ao inativar procedimentos"
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { classes, modalConfiguracoesStore } = this.props;
        const { notification, procedimentos, last, isLoading, search, ordenarTabela, propsTabsModal, loadingSave,procedimentoSelected ,isLoadingCsv} = this.state;
        
        return (
            <>
                <div className={classes.content}>
                    <PageTitle title={pageConfiguracoes("Procedimentos")}/>
                    <HeaderConfiguracoesButtonNovo
                        idPrefix="cfg-pro"
                        title="Procedimentos"
                        labelButton="Novo Procedimento"
                        handleClickNovo={this.handleClickNovoProcedimento}
                        search={{
                            handleChange: this.onChangeSearch,
                            value: search,
                            onKeypress: this.onKeypressSearch,
                            handleClickClear: this.handleClickClear,
                            onClickButtonSearch: this.handleClickSearch,
                        }}
                        secondaryButton={{
                            label: "Inativar Selecionados",
                            color: "#6c757d",
                            onClick: this.handleClickInativarSelecionados,
                            disabled: this.state.selectedProcedimentos.length === 0 || this.state.isLoading
                        }}
                    />
                    <div className={classes.contentList}>
                        <ContentConfiguracoes
                            quantidadeProcedimentos={procedimentos.length}
                            setAuditoriaTela={this.setAuditoriaTela}
                        >
                            <div className={classes.table}>
                                <Scroll
                                    loadMore={this.loadMore}
                                    hasMore={!last}
                                    pageStart={0}
                                    initialLoad={false}
                                >
                                    {procedimentos.length > 0 && <Table
                                        dados={procedimentos}
                                        columns={columnsProcedimentos({
                                            headerNome: "Nome do procedimento",
                                            functions: {
                                                handleEditar: this.handleEditar,
                                                handleDuplicar: this.handleDuplicar,
                                                handleDesativar: this.handleInativar,
                                                handleAtivar: this.handleAtivar,
                                            },
                                            selection: {
                                                selectedItems: this.state.selectedProcedimentos,
                                                onSelect: this.handleSelectProcedimento,
                                                onSelectAll: this.handleSelectAll,
                                                procedimentos: procedimentos
                                            }
                                        })}
                                        clickable={true}
                                        handleClick={this.handleClickRow}
                                        comOrdenacao
                                        ordenarTabela={ordenarTabela}
                                        handleClickOrdenar={(value) => this.handleClickOrdenar(value)}
                                    />}
                                    {
                                        isLoading && (
                                            <div className={classes.notFoundContainer}>
                                                <CircularProgress/>
                                            </div>
                                        )
                                    }
                                </Scroll>
                            </div>

                        </ContentConfiguracoes>
                        <div className={classes.floatButtons}>
                            <Button
                                id="cfg-pro-btn-nov"
                                shape='circle'
                                bgColor='#26ACA9'
                                onClick={this.handleClickNovoProcedimento}
                                shadow
                            >
                                <AddIcon />
                            </Button>
                            <Button
                                id="cfg-pro-btn-csv"
                                shape='circle'
                                bgColor='#F9BE73'
                                onClick={() => this.handleClickDownLoadCsv()}
                                shadow
                                disabled={isLoadingCsv}
                            >
                                <DownaloadIcon />
                            </Button>
                        </div>
                    </div>
                </div>
                {
                    modalConfiguracoesStore.showModal && 
                    <ModalConfiguracoesTabs
                        itemSelecionado={this.state.procedimentoSelected}
                        title={"Procedimento"}
                        renderHeader={this.renderHeader}
                        onClose={this.onCloseModal}
                        handleSave={this.handleSave}
                        loadingModal={this.state.loadingModal}
                        handleProcedimentoOdontologico={this.handleProcedimentoOdontologico}
                        loadingSave={loadingSave}
                        handleChangeOrientacao = {this.handleChangeOrientacao}
                        handleEspecialidade={this.handleEspecialidade}
                        especialidadesSelecionadas={procedimentoSelected?.especialidades || []}
                        showEspecialidades={true}
                        classes={{
                            content: procedimentoSelected?.id ? classes.contentModalEdit : classes.contentModal,
                            paper: classes.paper
                        }}
                        propsTabs={{
                            ...propsTabsModal,
                            changeTabSelected: this.changeTabSelectedModal,
                            handleClickSearch: this.handleClickSearchModal,
                            handleClickClear: this.handleClickClearModal,
                            onChangeSearch: this.onChangeSearchModal,
                            onKeypressSearch: this.onKeypressSearchModal,
                        }}
                        propsPopperCustom={{
                            handleEditar: this.handleEditar,
                            handleDuplicar: this.handleDuplicar,
                            handleDesativar: this.handleInativar,
                            handleAtivar: this.handleAtivar,
                        }}
                        propsTabsAuditoria={{
                            tabSelected: this.state.propsTabsAuditoria.tabSelected,
                            changeTabAuditoriaSelected: this.changeTabModalAuditoriaSelected,
                        }}
                    >
                        {
                            propsTabsModal.tabSelected === 0 ?
                            <ConvenioList
                                listaModal={this.state.convenios}
                                handleChangeCheckbox={this.handleChangeCheckbox}
                                handleChange={this.handleChange}
                                loadMore={this.loadMoreModal}
                                lastScroll={this.state.lastModal}
                                loadingModal={this.state.loadingModal}
                                procedimentoSelected={procedimentoSelected}
                                loadConvenios= {()=>this.loadConvenios()}
                                clearListConvenio={() => this.setState({ convenios: [] })}
                                handleEditar={this.handleEditar}
                            />
                            :
                            <ProdutoList
                                listaModal={this.state.produtos}
                                handleChangeCheckbox={this.handleChangeCheckbox}
                                handleChange={this.handleChange}
                                loadMore={this.loadMoreModal}
                                lastScroll={this.state.lastModal}
                                loadingModal={this.state.loadingModal}
                            />
                        }
                    </ModalConfiguracoesTabs>
                }
                <ModalConfirmacao
                    open={this.state.openModalConfirmacao}
                    classes={{
                        paperAlert: classes.paperAlert
                    }}
                    icon={<WarningIcon/>}
                    color={"yellow"}
                    title={`Confirmar inativação de ${this.state.selectAll ? this.state.totalProcedimentos : this.state.selectedProcedimentos.length} procedimento(s)`}
                    buttons={{
                        labelPrimaryButton: "Cancelar",
                        handlePrimaryButton: () => this.setState({ openModalConfirmacao: false }),
                        labelSecondButton: "Confirmar",
                        handleSecondButton:  this.handleClickInativar,
                        disabledPrimaryButton: this.state.isLoading,
                        disabledSecondButton: this.state.isLoading,
                        idPrimaryButton: 'cfg-pro-btn-cnc',
                        idSecondButton: 'cfg-pro-btn-cnf',
                    }}
                />
                <ModalConfirmacao
                    open={this.state.openAlertProcedimentos}
                    classes={{
                        paperAlert: classes.paperAlert
                    }}
                    icon={<WarningIcon/>}
                    color={"yellow"}
                    title={" Já foi criado um procedimento com esse nome"}
                    buttons={{
                        labelPrimaryButton: "Salvar assim mesmo",
                        handlePrimaryButton: () => this.saveProcedimentoComMesmoNome(),
                        labelSecondButton: "Voltar e alterar nome",
                        handleSecondButton: () => this.voltarMudarNome(),
                        disabledPrimaryButton: this.state.loadingSave,
                        disabledSecondButton: this.state.loadingSave,
                        idPrimaryButton: 'cfg-pro-btn-slv',
                        idSecondButton: 'cfg-pro-btn-vol',
                    }}
                />

                <Notification
					close={this.closeAlertMessage}
					reset={this.closeAlertMessage}
					isOpen={notification.isOpen}
					variant={notification.variant}
					message={notification.message}
				/>
            </>
        )
    }
};

export default withStyles(theme => ({
    content: {
        background: "#F5F5F5",
        "& #buttonCircle": {
            boxShadow: 'none',
            background: "#fff",
            color: "#5F6368",
        }
    },
    paper:{
        width:"820px"
    },
    contentModal: {
        height: "calc(100% - 238px) !important",
    },
    contentModalEdit: {
        height: "calc(100% - 278px)",
    },
    contentList: {
        display: 'flex',
        flexDirection: 'column',
        color: '#fff',
        fontWeight: 600,
        alignItems: 'center',
        padding: "24px 24px 0",
        gap: '16px',
        height: "calc(100% - 98px)",
    },
    table: {
        "&>div": {
            height: 'calc(100vh - 246px)',
            overflow: 'auto',
        },
        "& thead th": {
            textAlign: "left",
            top: 0,
            position: "sticky",
            zIndex: 1,
        },
    },
    notFoundContainer: {
        width: '100%',
        display: "flex",
        justifyContent: "center",
    },
    floatButtons: {
        position: 'absolute',
        bottom: 88,
        right: 37,
        zIndex: 100,
         gap:'3px',
        display:'flex'
    },
    titleField: {
        color: "#868686",
        fontSize: "12px",
    },
    header: {
        display: "flex",
        flexDirection: 'column',
    },
    titleRenderHeader: {
        color: "#868686",
        fontSize: "12px",
    },
    renderHeaderInput: {
        "&>div>div": {
            color: '#868686',
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontWeight: 600,
            height: '38px',
            background: '#f2f2f2',
            borderRadius: '8px',
            border: '0.5px solid rgba(220, 220, 220, 0.2)',
        },
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        gap: "16px",
    },
    contentNome: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    textField: {
        height: "40px",
        width: "100%",
        "& input": {
          height: "23px",
          background: "#F2F2F2",
          border: "0.5px solid rgba(220, 220, 220, 0.2)",
          borderRadius: "8px",
          fontFamily: "Poppins",
          fontSize: "14px",
          fontWeight: 600,
          color: '#868686',
        },
        "& ::placeholder": {
          color: '#000'
        },
    },
    notchedOutlineTextField: {
        "& fieldset": {
            border: "none",
        },
    },
    notchedOutline: {
        border: 'none',
    },
    paperAlert: {
        maxWidth: "373px",
    },
    reactSelectCheckbox: {
        whiteSpace: 'nowrap',
        "&>div": {
            height: '40px',
            "&>div:first-child": {
                flexWrap: 'nowrap',
                height: '40px',
            },
        },
    },
    labelResponsavel: {
        fontSize: '13px',
        color: '#868686',
        fontWeight: '200'
    },
    contentSelectPalmilha: {
        display: 'flex',
        flexDirection: 'column',
        width: '125px',
        justifyContent: 'space-between',
    },
    selectPalmilha: {
        width: '120px'
    },
    wraper: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: "10px",
    },
    contentInput: {
        display: "flex",
        flexDirection: "column",
        width: '10%',
    },
    contentInputProcedimento: {
        display: "flex",
        flexDirection: "column",
        width: '100%',
    },
    inputContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F2F2F2",
        width: "60px",
        height: "40px",
        color: "#505050",
        marginBottom: "8px",
        borderRadius: "8px",
        "&>div>input": {
            paddingRight: "0px",
        },
        border: 'none'
    },
    input: {
        color: "#505050",
        background: "#F2F2F2",
        border: "0 !important",
        borderRadius: "8px",
        height: "30px",
        boxSizing: "border-box",
        fontSize: "14px",
    },
    inputValor: {
        background: "#F2F2F2",
        padding: "4px 4px 4px 8px",
        width: "90px",
        height: "30px",
        border: "1px solid rgba(220, 220, 220, 0.2)",
        borderRadius: "8px",
    },
    valorCusto: {
        color: "#868686",
        fontSize: "12px"
    },
    containerCódigo: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: "15px"
    },
    wrapperInputCodigo: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: '635px'
    },
    inputValorCod: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    containerInputValorCusto: {
        width: "20%"
    },
}))(Procedimentos);
